import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Spring/LengthAndPerimeter/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'LengthAndPerimeter',
  field: 'Measurement',
  weeks: [4, 5],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/1MeasureInKilometresAndMetres" */ './1MeasureInKilometresAndMetres'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/2EquivalentLengthsKilometresAndMetres" */ './2EquivalentLengthsKilometresAndMetres'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/3PerimeterOnAGrid" */ './3PerimeterOnAGrid'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/4PerimeterOfARectangle" */ './4PerimeterOfARectangle'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/5PerimeterOfRectilinearShapes" */ './5PerimeterOfRectilinearShapes'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/6FindMissingLengthsInRectilinearShapes" */ './6FindMissingLengthsInRectilinearShapes'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/7CalculateThePerimeterOfRectilinearShapes" */ './7CalculateThePerimeterOfRectilinearShapes'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/8PerimeterOfRegularPolygons" */ './8PerimeterOfRegularPolygons'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/LengthAndPerimeter/9PerimeterOfPolygons" */ './9PerimeterOfPolygons'
        )
    })
  ]
});
export default Block;
